import { useQuery, useMutation } from "react-query";
import {
	add_opa_commission_api,
	get_opa_commission_api,
	get_contact_details_api,
	update_contact_details_api,
	get_mobile_configs_api,
	update_mobile_force_update_api,
} from "../services/settings";

export const useGetOpaCommission = () =>
	useQuery(["getOpaCommission"], () => get_opa_commission_api());

export const useAddOpaCommission = () =>
	useMutation("addOpaCommission", (body) => add_opa_commission_api(body));

export const useGetContactDetails = () =>
	useQuery(["getContactDetails"], () => get_contact_details_api());

export const useGetMobileConfigs = () =>
	useQuery(["getMobileConfigs"], () => get_mobile_configs_api());

export const useUpdateMobileForceUpdate = () =>
	useMutation("updateMobileForceUpdate", (body) =>
		update_mobile_force_update_api(body)
	);

export const useUpdateContactDetails = () =>
	useMutation("updateContactDetails", (body) =>
		update_contact_details_api(body)
	);
